import { render, staticRenderFns } from "./HapusForm.vue?vue&type=template&id=2a135f88&"
import script from "./HapusForm.vue?vue&type=script&lang=js&"
export * from "./HapusForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/jqwidgets/jqx.base.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports